/**
 * FontPicker
 *
 * Lets the user choose the handwriting font their card message prints in.
 * Shows the curated Thankster fonts as static preview images (hosted at
 * /card-fonts/<id>.png so the Thankster API key never reaches the client).
 */

import { CARD_FONTS } from '../../../../shared/src/cardFonts';

interface FontPickerProps {
  value:     number;
  onChange:  (id: number) => void;
  disabled?: boolean;
}

export default function FontPicker({ value, onChange, disabled }: FontPickerProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
      {CARD_FONTS.map((f) => {
        const selected = value === f.id;
        return (
          <button
            key={f.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(f.id)}
            aria-pressed={selected}
            className={`flex flex-col items-center justify-center gap-1.5 rounded-xl border px-2 py-2.5 transition-colors ${
              selected ? 'border-sage bg-sage/10' : 'border-gray-200 hover:border-sage/50'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <img
              src={`/card-fonts/${f.id}.png`}
              alt={`${f.label} sample`}
              loading="lazy"
              className="h-6 w-full object-contain"
            />
            <span className={`font-body text-[11px] leading-tight ${selected ? 'text-navy font-semibold' : 'text-gray-500'}`}>
              {f.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
